import type { Reencontrado } from '@abastece/core';
import { formatMoney, type Centavos } from '@abastece/shared';
import type { useT } from '../i18n/index.js';

/**
 * What a count found, before a correction (past) or after it (present): «faltaban C$ 80.00»,
 * «cuadra».
 */
export function loQueEncontro(t: ReturnType<typeof useT>, total: number, antes: boolean): string {
  const monto = formatMoney(Math.abs(total) as Centavos);
  if (total < 0) return t(antes ? 'conteoCaja.faltaban' : 'conteoCaja.faltan', { monto });
  if (total > 0) return t(antes ? 'conteoCaja.sobraban' : 'conteoCaja.sobran', { monto });
  return t(antes ? 'conteoCaja.cuadraba' : 'conteoCaja.cuadra');
}

/**
 * A count a correction reaches since (`reencontrar` in core), as the sheet says it before saving:
 * what it found and what it will find, or, for general cash's first count, what capital does.
 */
export function diceElConteo(t: ReturnType<typeof useT>, r: Reencontrado): string {
  if (r.inicial) {
    const capital = r.antes - r.despues;
    return t(capital > 0 ? 'encontrado.capitalBaja' : 'encontrado.capitalSube', { monto: formatMoney(Math.abs(capital) as Centavos) });
  }
  return t('encontrado.enEse', { antes: loQueEncontro(t, r.antes, true), despues: loQueEncontro(t, r.despues, false) });
}
